<mat-card class="cardT veiculos-titulo">
  <span>Veículos</span>

  <span class="veiculos-acoes" *ngIf="hasLevelAdm">
    <button
      mat-icon-button
      type="button"
      matTooltip="Veículos"
      [class.veiculos-acao--ativa]="modoExibicao === 'veiculos'"
      [disabled]="modoExibicao === 'veiculos'"
      (click)="exibirVeiculos()">
      <mat-icon>directions_car</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Postos de Combustível"
      [class.veiculos-acao--ativa]="modoExibicao === 'postos'"
      [disabled]="modoExibicao === 'postos'"
      (click)="exibirPostos()">
      <mat-icon>local_gas_station</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Veículos sem usuário"
      [class.veiculos-acao--ativa]="modoExibicao === 'sem-usuario'"
      [disabled]="modoExibicao === 'sem-usuario'"
      (click)="exibirVeiculosSemUsuario()">
      <mat-icon>person_off</mat-icon>
    </button>
  </span>
</mat-card>
<div>
  <app-lista-dados
    *ngIf="modoExibicao === 'veiculos'"
    [upTitulo]="'Lista de Veículos'"
    [upIcone]="'directions_car'"
    [upCor]="'3F51B5'"
    [upDados]="veiculos"
    [upColunas]="colunasListaDados"
    [upHabilitaEditarLinha]="false"
    [upLargura]="3"
    [upHabilitaContador]="true"
    [upHabilitaFiltroRapido]="true"
    [upCarregando]="!!subscription"
    (ueBotaoIncluir)="onCreate()"
    (ueBotaoEditar)="onEdit($event)"
    (ueBotaoExcluir)="onDelete($event)">
  </app-lista-dados>

  <app-list-postos *ngIf="modoExibicao === 'postos'"></app-list-postos>
  <app-veiculos-sem-usuario *ngIf="modoExibicao === 'sem-usuario'"></app-veiculos-sem-usuario>
</div>
